import React from 'react';
import PageBanner from '@components/PageBanner';
function WebinarBanner() {
    return (React.createElement(PageBanner, { visibilityUrl: "/api/internal/ai_banner", dismissKey: "webinar-banner-dismissed", hrefLink: "https://us02web.zoom.us/webinar/register/WN_PPuVUAkRQBeC-d6waCboPQ#/registration", iconPrefix: React.createElement("i", { className: "fa-light fa-megaphone" }), text: React.createElement("p", null, "Our new AI tool, Inspection Assistant, is live! Register today to see it live on Thursday, October 9th at 1pm EST") }));
}
export default WebinarBanner;
